import { createContext } from 'react';
import Konva from 'konva';

type StageValue = {
  stageRef: React.RefObject<Konva.Stage | null> | ((instance: Konva.Stage | null) => void) | null;
  container: Konva.Image;
  scale: number;
};

export const StageContext = createContext<StageValue>(null as unknown as StageValue);
